const projectsData = {
    all: [
        {
            title: "AlgoOlio - AI Powered Tech Interview Preparation",
            description: "A startup project focused on providing scalable solutions with a fully integrated MERN stack and CI/CD pipeline.",
            detailDescription: "AlgoOlio is an end-to-end platform for mastering technical interviews through AI-driven code evaluation and real-time feedback mechanisms.",
            image: 'assets/projectImages/ALGOOLIO.jpg',
            video: 'assets/projectVideos/ALGOOLIO.mp4',
            highlights: [
                "Developed an AI-powered web-application for users to prepare for technical assessments.",
                "AI-powered coding environment for tailored insights and guidance",
                "Resume parser to evaluate and improve resume writing for specific job descriptions.",
                "Virtual interviewer for users to practice tech interviews and get scores and feedback.",
                "Secured initial 10k in funding and developed financial strategies."
            ],
            detailedHighlights: [
                "Spearheaded multimodal AI analysis development for the Virtual Interviewer.",
                "Adopted different feature fusion strategies to improve inference accuracy by 34%.",
                "Fine-tuned and quantized models for optimized performance on production.",
                "Cloud deployment infrastructure on Google Cloud Run with DockerHub for containerization.",
                "Architected backend Flask application with MongoDB database.",
                "Built robust frontend interfaces in React.js, incorporating dynamic dashboards for visualizing user progress and analytics.",
                "Project stack: MERN stack (MongoDB, Express.js, React.js, Node.js), Google Cloud Run, AWS EKS, Docker."
            ],
            skills: [
                "React.js",
                "Express.js",
                "Node.js",
                "MongoDB",
                "JavaScript",
                "TypeScript",
                "Python",
                "CSS",
                "Deep Learning",
                "AWS",
                "Google Cloud Run",
                "Docker"
            ]
        },
        {
            title: "Clinical Gait Analysis",
            description: "A custom trained model to analyse gait patterns and provide preliminary knee-related diagnosis.",
            detailDescription: "This project employed deep learning techniques to classify gait-issues using spatial and temporal features from videos. After experimenting with various model architectures, a lightweight TSN model was trained for multiclass classification.",
            image: "assets/projectImages/walking.jpg",
            video: "assets/projectVideos/gait.mp4",
            highlights: [
                "Trained and evaluated Lightweight TSN, SlowFast Network, TimeSFormer architectures for multiclass classification task.",
                "Integrated Lightweight TSN into web application for gait analysis use case.",
            ],
            detailedHighlights: [
                "Implemented PEFT for multiple architectures, comparing accuracy, recall and F1-scores as evaluative metrics.",
                "Selected Lightweight TSN with an Efficientnet_b3 backbone due to performance and architectural size.",
                "Successfully classifies 4 different classes of gait-related diagnosis.",
                "Project stack: PyTorch, Python, Transformers, Streamlit."
            ],
            skills: [
                "Deep Learning",
                "Python",
                "PyTorch"
            ]
        },
        {
            title: "Movie Sentiment Analysis - NLP Sentiment Classification",
            description: "A custom trained NLP model to provide users with a summary of sentiments based on movie reviews.",
            detailDescription: "This project leveraged NLP techniques to classify sentiments from movie reviews. Using a custom CRNN-CNN-RNN architecture, the model integrated pre-trained GloVe embeddings for semantic understanding and a fusion of convolutional and recurrent layers for robust feature extraction.",
            image: "assets/projectImages/NLPSentiment_Screenshot.jpg",
            highlights: [
                "Fine-tuned a custom CRNN-CNN-RNN fusion model by feature fusion.",
                "Experimented with other model architectures such as BERT and GPT-Neo.",
                "Achieved an overall accuracy of 94.05%, recall of 95.26%, and F-score of 94.11%."
            ],
            detailedHighlights: [
                "Designed a CRNN-CNN-RNN architecture incorporating convolutional, recurrent, and fully connected layers for feature extraction and sentiment classification.",
                "Integrated pre-trained GloVe embeddings from the GloVe 6B 100d dataset into the embedding layer, which remained frozen during training to retain semantic richness.",
                "Implemented a 1D convolutional layer with ReLU activation and a kernel size of 5 to extract local patterns from input text embeddings.",
                "Added a GRU (Gated Recurrent Unit) layer to process sequential outputs from the convolutional layer, modeling long-term dependencies efficiently compared to LSTM.",
                "Connected a fully connected layer to the final GRU hidden state for binary sentiment classification (positive/negative).",
                "Incorporated dropout layers after the embedding, convolutional, and recurrent layers to minimize overfitting and improve generalization.",
                "Compared CRNN-CNN-RNN performance with transformer-based architectures like BERT and GPT-Neo to analyze trade-offs between computational efficiency and accuracy.",
                "Used PyTorch Lightning to structure the training pipeline, enabling dynamic monitoring with TensorBoard.",
                "Project stack: PyTorch, Python, TensorBoard, GloVe Embeddings."
            ],
            skills: [
                "NLP",
                "Python",
                "PyTorch"
            ]
        },
        {
            title: "NutriVision - Nutritional Estimate Application",
            description: "A web-based Computer Vision tool for users to obtain real-time nutrition estimates for their dishes.",
            detailDescription: "NutriVision estimates the nutritional content of meals based on visual data. It combines ingredient classification with portion size estimation to deliver reliable nutritional insights.",
            image: 'assets/projectImages/NutriVision_Screenshot.png',
            video: 'assets/projectVideos/NutriVisionVideo.mp4',
            highlights: [
                "Fine-tuned EfficientNet_V2_S for image classification of ingredients.",
                "Fine-tuned multi-task regression model to output nutritional breakdown.",
                "Implemented distance scaling using monocular depth-estimation model.",
                "Achieved average MAE of 0.0342."
            ],
            detailedHighlights: [
                "Integrated EfficientNet_V2_S as the backbone for ingredient classification, achieving high accuracy across the Nutrition-5k dataset.",
                "Experimented with other classification models such as ResNet50 and ResNet101 for benchmarking comparisons.",
                "Built a multi-task regression model trained on nutritional data (calories, macronutrients) to output personalized nutritional insights.",
                "Made use of depth-scaling mechanism using monocular depth-estimation models like Metric3d to calculate serving sizes.",
                "Preprocessed datasets by segmenting ingredients and normalizing variations in food presentation using data augmentation techniques.",
                "Optimized predictions with cross-validation and reduced MAE to 0.0342 by leveraging transfer learning.",
                "Project stack: Python, EfficientNet_V2_S, PyTorch, TensorFlow."
            ],
            skills: [
                "Computer Vision",
                "Deep Learning",
                "Python",
                "PyTorch",
                "TensorFlow",
            ]
        },
        {
            title: "TideTip - Rip Current Detection",
            description: "A Computer Vision-based system designed to enhance beach safety by identifying rip currents in real-time video submissions.",
            detailDescription: "TideTip detects hazardous rip currents in real-time using advanced computer vision techniques, assisting authorities in ensuring beachgoer safety.",
            image: 'assets/projectImages/TideTip_Screenshot.png',
            video: 'assets/projectVideos/TideTipLiveView.mp4',
            highlights: [
                "Implemented using YOLOv5, YOLOv8, RetinaNet, and Faster RCNN.",
                "Trained models on AWS SageMaker and Google Colab.",
                "Built a web interface for users to submit real-time video for rip current analysis."
            ],
            detailedHighlights: [
                "Designed a comparative analysis framework to evaluate YOLOv5, YOLOv8, RetinaNet, and Faster RCNN for rip current detection, optimizing detection accuracy and inference speed.",
                "Trained models using large-scale annotated datasets of rip current imagery, leveraging AWS SageMaker for distributed training.",
                "Implemented a web-based real-time video analysis tool using Flask for backend processing and OpenCV for frame extraction and preprocessing.",
                "Optimized models with techniques like anchor box clustering and multi-scale training to handle varying resolutions and oceanic patterns.",
                "Achieved a detection accuracy of over 92%, enabling early detection and intervention by beach safety teams.",
                "Project stack: YOLOv5, YOLOv8, RetinaNet, AWS SageMaker, Google Colab, Flask, OpenCV."
            ],
            skills: [
                "Computer Vision",
                "Deep Learning",
                "Python",
                "PyTorch",
                "TensorFlow",
                "AWS Sagemaker",
                "OpenCV",
                "Flask"
            ]
        },
        {
            title: "Tenant-Landlord Portal",
            description: "A web-based platform to streamline communications between tenants and landlords, facilitating job tracking and transparent updates.",
            detailDescription: "This project simplifies tenant-landlord interactions by enabling ticket-based job tracking and streamlined communication through role-based permissions.",
            image: 'assets/projectImages/tenant_landlord_screenshot.png',
            highlights: [
                "User roles: Admin, Landlord, Tenant.",
                "Implemented using React.js, Tailwind CSS, and MongoDB.",
                "Real-time updates and permissions-based functionalities for transparent communication.",
            ],
            detailedHighlights: [
                "Developed a ticketing system for complaint resolution with status tracking and notifications.",
                "Designed a multi-tier architecture using React.js for the frontend, Feathers.js for the backend, and MongoDB for data storage.",
                "Implemented real-time communication with WebSocket protocols, enabling instant status updates and feedback loops.",
                "Enhanced the admin interface with dynamic analytics for tracking tenant and landlord activity.",
                "Project stack: MERN stack (MongoDB, Express.js, React.js, Node.js), Tailwind CSS, Jest, Mocha."
            ],
            skills: [
                "React.js",
                "Feather.js",
                "Jest",
                "Mocha",
                "JavaScript",
                "TypeScript",
                "Tailwind CSS",
                "HTML5"
            ]
        },
        {
            title: "Automation Dashboard Reporting",
            description: "An automated dashboard to streamline monthly reports for Youth Services, significantly reducing manual work.",
            detailDescription: "This project involved designing and implementing an automated reporting system to process and visualize monthly Youth Services data, reducing manual efforts and improving accuracy.",
            image: 'assets/projectImages/dashboard_screenshot.png',
            highlights: [
                "Utilized Python, Pandas, and Matplotlib for data manipulation and visualization.",
                "Reduced report preparation time by 80%.",
                "Built with Streamlit for interactive and user-friendly reporting.",
                "Built an alternative dashboarding system with Power Bi."
            ],
            detailedHighlights: [
                "Automated the ingestion and cleaning of raw CSV datasets using Pandas, ensuring consistent data quality.",
                "Created multi-layered data aggregation pipelines to compute KPIs and generate time-series metrics.",
                "Designed interactive and dynamic visualizations with Matplotlib and Plotly to highlight trends and insights.",
                "Built a Streamlit-based dashboard for users to access reports, export results, and customize visualizations.",
                "Streamlined workflows, reducing manual reporting time by 80% and enabling real-time updates to dashboards.",
                "Connected data sources such as SalesForce and Sharepoint files to Power Bi for alternative dashboarding.",
                "Project stack: Python(Matplotlib, Numpy, Pandas, Streamlit), Power Bi."
            ],
            skills: [
                "Data Analytics",
                "Python",
                "Power Bi",
            ]
        },
        {
            title: "Generative AI-Powered Web Application (Internship Project)",
            description: "A SaaS web application with generative AI capabilities to enhance user experience and streamline business operations.",
            detailDescription: "This project leveraged generative AI to power SaaS functionalities like intelligent text processing, workflow automation, and user content generation.",
            image: 'assets/projectImages/raijin_image.jpg',
            highlights: [
                "Led frontend development and integrated OpenAI API.",
                "Used Cypress for end-to-end testing.",
                "Collaborated in an Agile environment, conducting user interviews and scoping project requirements.",
            ],
            detailedHighlights: [
                "Integrated OpenAI’s GPT models for text summarization, completion, and generation to streamline workflows.",
                "Integrated third-party applications such as GoogleDrive and Slack to enhance platform capabilities.",
                "Developed React.js components for user interaction, enabling dynamic generation of templates and responses.",
                "Implemented secure API integration with token-based authentication to protect sensitive user interactions.",
                "Used Cypress to write automated end-to-end tests, achieving 95% test coverage across all workflows.",
                "Collaborated with cross-functional teams in Agile sprints to define and refine MVP features.",
                "Project stack: JavaScript, TypeScript, Python, React.js, Django, Cypress."
            ],
            skills: [
                "React.js",
                "Django",
                "PostgreSQL",
                "REST Framework",
                "JavaScript",
                "TypeScript",
                "Python",
                "E2E-Testing",
                "API Integration"
            ]
        },
        {
            title: "Animal Behavior Analysis with AI",
            description: "AI-based research project focused on animal behavior analysis using deep learning for multi-label classification.",
            detailDescription: "This research utilized computer vision and deep learning techniques to classify and analyze various animal behaviors from video and image datasets.",
            image: 'assets/projectImages/bird_image.jpg',
            highlights: [
                "Implemented with PyTorch for model training and Scikit-Multilearn for multi-label classification.",
                "Experimented with AlexNet, ResNet-50, and VGG-16 for image classification.",
                "Analyzed differences in accuracy and performance across various deep learning models.",
            ],
            detailedHighlights: [
                "Built a multi-label classification system using PyTorch, enabling simultaneous prediction of multiple behavior categories.",
                "Utilized Scikit-Multilearn to implement hierarchical label propagation for better classification accuracy.",
                "Conducted extensive benchmarking on AlexNet, ResNet-50, and VGG-16, optimizing hyperparameters such as learning rates, batch sizes, and activation functions.",
                "Augmented the dataset with synthetic transformations, including rotation, cropping, and brightness adjustments, to increase robustness.",
                "Achieved improved model performance metrics, with accuracy enhancements of up to 10% after fine-tuning on domain-specific data.",
                "Project stack: PyTorch, Scikit-Multilearn, AlexNet, ResNet-50, VGG-16."
            ],
            skills: [
                "Computer Vision",
                "Deep Learning",
                "Python",
                "PyTorch",
                "TensorFlow",
                "Scikit-Learn"
            ]
        }        
    ],
    softwareDevelopment: [
        {
            title: "AlgoOlio - AI Powered Tech Interview Preparation",
            description: "A startup project focused on providing scalable solutions with a fully integrated MERN stack and CI/CD pipeline.",
            detailDescription: "AlgoOlio is an end-to-end platform for mastering technical interviews through AI-driven code evaluation and real-time feedback mechanisms.",
            image: 'assets/projectImages/ALGOOLIO.jpg',
            video: 'assets/projectVideos/ALGOOLIO.mp4',
            highlights: [
                "Developed an AI-powered web-application for users to prepare for technical assessments.",
                "AI-powered coding environment for tailored insights and guidance",
                "Resume parser to evaluate and improve resume writing for specific job descriptions.",
                "Virtual interviewer for users to practice tech interviews and get scores and feedback.",
                "Secured initial 10k in funding and developed financial strategies."
            ],
            detailedHighlights: [
                "Spearheaded multimodal AI analysis development for the Virtual Interviewer.",
                "Adopted different feature fusion strategies to improve inference accuracy by 34%.",
                "Fine-tuned and quantized models for optimized performance on production.",
                "Cloud deployment infrastructure on Google Cloud Run with DockerHub for containerization.",
                "Architected backend Flask application with MongoDB database.",
                "Built robust frontend interfaces in React.js, incorporating dynamic dashboards for visualizing user progress and analytics.",
                "Project stack: MERN stack (MongoDB, Express.js, React.js, Node.js), Google Cloud Run, AWS EKS, Docker."
            ],
            skills: [
                "React.js",
                "Express.js",
                "Node.js",
                "MongoDB",
                "JavaScript",
                "TypeScript",
                "Python",
                "CSS",
                "Deep Learning",
                "AWS",
                "Google Cloud Run",
                "Docker"
            ]
        },
        {
            title: "Tenant-Landlord Portal",
            description: "A web-based platform to streamline communications between tenants and landlords, facilitating job tracking and transparent updates.",
            detailDescription: "This project simplifies tenant-landlord interactions by enabling ticket-based job tracking and streamlined communication through role-based permissions.",
            image: 'assets/projectImages/tenant_landlord_screenshot.png',
            highlights: [
                "User roles: Admin, Landlord, Tenant.",
                "Implemented using React.js, Tailwind CSS, and MongoDB.",
                "Real-time updates and permissions-based functionalities for transparent communication."
            ],
            detailedHighlights: [
                "Developed a ticketing system for complaint resolution with status tracking and notifications.",
                "Designed a multi-tier architecture using React.js for the frontend, Feathers.js for the backend, and MongoDB for data storage.",
                "Implemented real-time communication with WebSocket protocols, enabling instant status updates and feedback loops.",
                "Enhanced the admin interface with dynamic analytics for tracking tenant and landlord activity.",
                "Project stack: MERN stack (MongoDB, Express.js, React.js, Node.js), Tailwind CSS, Jest, Mocha."
            ],
            skills: [
                "React.js",
                "Feather.js",
                "Jest",
                "Mocha",
                "JavaScript",
                "TypeScript",
                "Tailwind CSS",
                "HTML5"
            ]
        },
        {
            title: "Automation Dashboard Reporting",
            description: "An automated dashboard to streamline monthly reports for Youth Services, significantly reducing manual work.",
            detailDescription: "This project involved designing and implementing an automated reporting system to process and visualize monthly Youth Services data, reducing manual efforts and improving accuracy.",
            image: 'assets/projectImages/dashboard_screenshot.png',
            highlights: [
                "Utilized Python, Pandas, and Matplotlib for data manipulation and visualization.",
                "Reduced report preparation time by 80%.",
                "Built with Streamlit for interactive and user-friendly reporting.",
                "Built an alternative dashboarding system with Power Bi."
            ],
            detailedHighlights: [
                "Automated the ingestion and cleaning of raw CSV datasets using Pandas, ensuring consistent data quality.",
                "Created multi-layered data aggregation pipelines to compute KPIs and generate time-series metrics.",
                "Designed interactive and dynamic visualizations with Matplotlib and Plotly to highlight trends and insights.",
                "Built a Streamlit-based dashboard for users to access reports, export results, and customize visualizations.",
                "Streamlined workflows, reducing manual reporting time by 80% and enabling real-time updates to dashboards.",
                "Connected data sources such as SalesForce and Sharepoint files to Power Bi for alternative dashboarding.",
                "Project stack: Python(Matplotlib, Numpy, Pandas, Streamlit), Power Bi."
            ],
            skills: [
                "Data Analytics",
                "Python",
                "Power Bi",
            ]
        },
        {
            title: "Generative AI-Powered Web Application (Internship Project)",
            description: "A SaaS web application with generative AI capabilities to enhance user experience and streamline business operations.",
            detailDescription: "This project leveraged generative AI to power SaaS functionalities like intelligent text processing, workflow automation, and user content generation.",
            image: 'assets/projectImages/raijin_image.jpg',
            highlights: [
                "Led frontend development and integrated OpenAI API.",
                "Used Cypress for end-to-end testing.",
                "Collaborated in an Agile environment, conducting user interviews and scoping project requirements.",
            ],
            detailedHighlights: [
                "Integrated OpenAI’s GPT models for text summarization, completion, and generation to streamline workflows.",
                "Integrated third-party applications such as GoogleDrive and Slack to enhance platform capabilities.",
                "Developed React.js components for user interaction, enabling dynamic generation of templates and responses.",
                "Implemented secure API integration with token-based authentication to protect sensitive user interactions.",
                "Used Cypress to write automated end-to-end tests, achieving 95% test coverage across all workflows.",
                "Collaborated with cross-functional teams in Agile sprints to define and refine MVP features.",
                "Project stack: JavaScript, TypeScript, Python, React.js, Django, Cypress."
            ],
            skills: [
                "React.js",
                "Django",
                "PostgreSQL",
                "REST Framework",
                "JavaScript",
                "TypeScript",
                "Python",
                "E2E-Testing",
                "API Integration"
            ]
        }
    ],
    AIML: [
        {
            title: "AlgoOlio - AI Powered Tech Interview Preparation",
            description: "A startup project focused on providing scalable solutions with a fully integrated MERN stack and CI/CD pipeline.",
            detailDescription: "AlgoOlio is an end-to-end platform for mastering technical interviews through AI-driven code evaluation and real-time feedback mechanisms.",
            image: 'assets/projectImages/ALGOOLIO.jpg',
            video: 'assets/projectVideos/ALGOOLIO.mp4',
            highlights: [
                "Developed an AI-powered web-application for users to prepare for technical assessments.",
                "AI-powered coding environment for tailored insights and guidance",
                "Resume parser to evaluate and improve resume writing for specific job descriptions.",
                "Virtual interviewer for users to practice tech interviews and get scores and feedback.",
                "Secured initial 10k in funding and developed financial strategies."
            ],
            detailedHighlights: [
                "Spearheaded multimodal AI analysis development for the Virtual Interviewer.",
                "Adopted different feature fusion strategies to improve inference accuracy by 34%.",
                "Fine-tuned and quantized models for optimized performance on production.",
                "Cloud deployment infrastructure on Google Cloud Run with DockerHub for containerization.",
                "Architected backend Flask application with MongoDB database.",
                "Built robust frontend interfaces in React.js, incorporating dynamic dashboards for visualizing user progress and analytics.",
                "Project stack: MERN stack (MongoDB, Express.js, React.js, Node.js), Google Cloud Run, AWS EKS, Docker."
            ],
            skills: [
                "React.js",
                "Express.js",
                "Node.js",
                "MongoDB",
                "JavaScript",
                "TypeScript",
                "Python",
                "CSS",
                "Deep Learning",
                "AWS",
                "Google Cloud Run",
                "Docker"
            ]
        },
        {
            title: "Clinical Gait Analysis",
            description: "A custom trained model to analyse gait patterns and provide preliminary knee-related diagnosis.",
            detailDescription: "This project employed deep learning techniques to classify gait-issues using spatial and temporal features from videos. After experimenting with various model architectures, a lightweight TSN model was trained for multiclass classification.",
            image: "assets/projectImages/walking.jpg",
            video: "assets/projectVideos/gait.mp4",
            highlights: [
                "Trained and evaluated Lightweight TSN, SlowFast Network, TimeSFormer architectures for multiclass classification task.",
                "Integrated Lightweight TSN into web application for gait analysis use case.",
            ],
            detailedHighlights: [
                "Implemented PEFT for multiple architectures, comparing accuracy, recall and F1-scores as evaluative metrics.",
                "Selected Lightweight TSN with an Efficientnet_b3 backbone due to performance and architectural size.",
                "Successfully classifies 4 different classes of gait-related diagnosis.",
                "Project stack: PyTorch, Python, Transformers, Streamlit."
            ],
            skills: [
                "Deep Learning",
                "Python",
                "PyTorch"
            ]
        },
        {
            title: "Movie Sentiment Analysis - NLP Sentiment Classification",
            description: "A custom trained NLP model to provide users with a summary of sentiments based on movie reviews.",
            detailDescription: "This project leveraged NLP techniques to classify sentiments from movie reviews. Using a custom CRNN-CNN-RNN architecture, the model integrated pre-trained GloVe embeddings for semantic understanding and a fusion of convolutional and recurrent layers for robust feature extraction.",
            image: "assets/projectImages/NLPSentiment_Screenshot.jpg",
            highlights: [
                "Fine-tuned a custom CRNN-CNN-RNN fusion model by feature fusion.",
                "Experimented with other model architectures such as BERT and GPT-Neo.",
                "Achieved an overall accuracy of 94.05%, recall of 95.26%, and F-score of 94.11%."
            ],
            detailedHighlights: [
                "Designed a CRNN-CNN-RNN architecture incorporating convolutional, recurrent, and fully connected layers for feature extraction and sentiment classification.",
                "Integrated pre-trained GloVe embeddings from the GloVe 6B 100d dataset into the embedding layer, which remained frozen during training to retain semantic richness.",
                "Implemented a 1D convolutional layer with ReLU activation and a kernel size of 5 to extract local patterns from input text embeddings.",
                "Added a GRU (Gated Recurrent Unit) layer to process sequential outputs from the convolutional layer, modeling long-term dependencies efficiently compared to LSTM.",
                "Connected a fully connected layer to the final GRU hidden state for binary sentiment classification (positive/negative).",
                "Incorporated dropout layers after the embedding, convolutional, and recurrent layers to minimize overfitting and improve generalization.",
                "Compared CRNN-CNN-RNN performance with transformer-based architectures like BERT and GPT-Neo to analyze trade-offs between computational efficiency and accuracy.",
                "Used PyTorch Lightning to structure the training pipeline, enabling dynamic monitoring with TensorBoard.",
                "Project stack: PyTorch, Python, TensorBoard, GloVe Embeddings."
            ],
            skills: [
                "NLP",
                "Python",
                "PyTorch"
            ]
        },
        {
            title: "NutriVision - Nutritional Estimate Application",
            description: "A web-based Computer Vision tool for users to obtain real-time nutrition estimates for their dishes.",
            detailDescription: "NutriVision estimates the nutritional content of meals based on visual data. It combines ingredient classification with portion size estimation to deliver reliable nutritional insights.",
            image: 'assets/projectImages/NutriVision_Screenshot.png',
            video: 'assets/projectVideos/NutriVisionVideo.mp4',
            highlights: [
                "Fine-tuned EfficientNet_V2_S for image classification of ingredients.",
                "Fine-tuned multi-task regression model to output nutritional breakdown.",
                "Implemented distance scaling using monocular depth-estimation model.",
                "Achieved average MAE of 0.0342."
            ],
            detailedHighlights: [
                "Integrated EfficientNet_V2_S as the backbone for ingredient classification, achieving high accuracy across the Nutrition-5k dataset.",
                "Experimented with other classification models such as ResNet50 and ResNet101 for benchmarking comparisons.",
                "Built a multi-task regression model trained on nutritional data (calories, macronutrients) to output personalized nutritional insights.",
                "Made use of depth-scaling mechanism using monocular depth-estimation models like Metric3d to calculate serving sizes.",
                "Preprocessed datasets by segmenting ingredients and normalizing variations in food presentation using data augmentation techniques.",
                "Optimized predictions with cross-validation and reduced MAE to 0.0342 by leveraging transfer learning.",
                "Project stack: Python, EfficientNet_V2_S, PyTorch, TensorFlow."
            ],
            skills: [
                "Computer Vision",
                "Deep Learning",
                "Python",
                "PyTorch",
                "TensorFlow",
            ]
        },
        {
            title: "TideTip - Rip Current Detection",
            description: "A Computer Vision-based system designed to enhance beach safety by identifying rip currents in real-time video submissions.",
            detailDescription: "TideTip detects hazardous rip currents in real-time using advanced computer vision techniques, assisting authorities in ensuring beachgoer safety.",
            image: 'assets/projectImages/TideTip_Screenshot.png',
            video: 'assets/projectVideos/TideTipLiveView.mp4',
            highlights: [
                "Implemented using YOLOv5, YOLOv8, RetinaNet, and Faster RCNN.",
                "Trained models on AWS SageMaker and Google Colab.",
                "Built a web interface for users to submit real-time video for rip current analysis."
            ],
            detailedHighlights: [
                "Designed a comparative analysis framework to evaluate YOLOv5, YOLOv8, RetinaNet, and Faster RCNN for rip current detection, optimizing detection accuracy and inference speed.",
                "Trained models using large-scale annotated datasets of rip current imagery, leveraging AWS SageMaker for distributed training.",
                "Implemented a web-based real-time video analysis tool using Flask for backend processing and OpenCV for frame extraction and preprocessing.",
                "Optimized models with techniques like anchor box clustering and multi-scale training to handle varying resolutions and oceanic patterns.",
                "Achieved a detection accuracy of over 92%, enabling early detection and intervention by beach safety teams.",
                "Project stack: YOLOv5, YOLOv8, RetinaNet, AWS SageMaker, Google Colab, Flask, OpenCV."
            ],
            skills: [
                "Computer Vision",
                "Deep Learning",
                "Python",
                "PyTorch",
                "TensorFlow",
                "AWS Sagemaker",
                "OpenCV",
                "Flask"
            ]
        },
        {
            title: "Animal Behavior Analysis with AI",
            description: "AI-based research project focused on animal behavior analysis using deep learning for multi-label classification.",
            detailDescription: "This research utilized computer vision and deep learning techniques to classify and analyze various animal behaviors from video and image datasets.",
            image: 'assets/projectImages/bird_image.jpg',
            highlights: [
                "Implemented with PyTorch for model training and Scikit-Multilearn for multi-label classification.",
                "Experimented with AlexNet, ResNet-50, and VGG-16 for image classification.",
                "Analyzed differences in accuracy and performance across various deep learning models.",
            ],
            detailedHighlights: [
                "Built a multi-label classification system using PyTorch, enabling simultaneous prediction of multiple behavior categories.",
                "Utilized Scikit-Multilearn to implement hierarchical label propagation for better classification accuracy.",
                "Conducted extensive benchmarking on AlexNet, ResNet-50, and VGG-16, optimizing hyperparameters such as learning rates, batch sizes, and activation functions.",
                "Augmented the dataset with synthetic transformations, including rotation, cropping, and brightness adjustments, to increase robustness.",
                "Achieved improved model performance metrics, with accuracy enhancements of up to 10% after fine-tuning on domain-specific data.",
                "Project stack: PyTorch, Scikit-Multilearn, AlexNet, ResNet-50, VGG-16."
            ],
            skills: [
                "Computer Vision",
                "Deep Learning",
                "Python",
                "PyTorch",
                "TensorFlow",
                "Scikit-Learn"
            ]
        }
    ]
};

export default projectsData;